import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useCallback, Fragment } from "react";
import { sass } from "../../sass/sass.js";
import { useFocusModal } from "./useFocusModal.js";
import "../useWindowSize/useWindowSize.js";
import "../useWindowSize/WindowSizeContext.js";
import "../../utils/noOp.js";
import "../../isObject-ec23ace2.js";
import "../../isSymbol-c6f5cd95.js";
import "./FocusModalContext.js";
const TARGET_PADDING = 4;
function FlashFocusModalTarget(props) {
  const { elementId, children } = props, [containerRect, setContainerRect] = useState(), { isCurrentTarget, targetZIndex } = useFocusModal(elementId), containerRef = useCallback((node) => {
    node && setContainerRect(node.getBoundingClientRect());
  }, []);
  if (!isCurrentTarget)
    return /* @__PURE__ */ jsx(Fragment, { children });
  const highlightStyle = containerRect ? {
    top: -TARGET_PADDING,
    left: -TARGET_PADDING,
    height: containerRect.height + 2 * TARGET_PADDING,
    width: containerRect.width + 2 * TARGET_PADDING,
    "--bs-border-color": sass.color.flash.semantic.border.interactive
  } : {};
  return /* @__PURE__ */ jsxs("div", { className: "position-relative pe-none", style: { zIndex: targetZIndex }, ref: containerRef, children: [
    /* @__PURE__ */ jsx("div", { className: "position-absolute border border-3 rounded-1", style: highlightStyle }),
    children
  ] });
}
export {
  FlashFocusModalTarget
};
//# sourceMappingURL=FlashFocusModalTarget.js.map
